const emailAddress = 'info@themigraineclinic.org'
const phoneNumber = '020 220 0233'
const phoneNumberNoSpace = '0202200233'

export const CONTACT_DETAILS = {
  emailAddress,
  phoneNumber,
  emailHref: `mailto:${emailAddress}`,
  phoneHref: `tel:${phoneNumberNoSpace}`,
} as const
